module.exports = __webpack_public_path__ + "static/img/target_a5.7532ba1f.png";